import React from 'react';
import NavBar from './NavBar';
import TopBar from './TopBar';
import { Content, ContentContainer, Root, Wrapper } from './style';

const Layout = ({ children, ...rest }) => {
  return (
    <Root {...rest}>
      <TopBar />
      <NavBar />
      <Wrapper offset={1}>
        <ContentContainer>
          <Content>{children}</Content>
        </ContentContainer>
      </Wrapper>
    </Root>
  );
};

export default Layout;
